var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shareButton"},[_c('a',{attrs:{"id":"openApp"},on:{"click":_vm.openApp}},[_vm._v("请使用浏览器打开")])])}
var staticRenderFns = []

export { render, staticRenderFns }